import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import 'moment/locale/it';
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import { ICreditsInterface } from '../../redux/credits/credits.reducers';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as ProductInfoActions from '../../redux/productinfo/productinfo.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import * as VarActions from '../../redux/vars/vars.actions';
import ReduxLanguage from '../../components/ReduxLanguage';

const styles = createStyles({
  header: {
    backgroundColor: 'white',
    width: '100%',
    zIndex: 200,
    padding: 10,
    paddingRight: 20,
    borderBottom: '2px solid #5AC0B1',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface IProductInfoProps extends WithStyles<typeof styles> {
  language: string;
  credits: ICreditsInterface;
}

export type ComponentProps = IProductInfoProps & IReduxProps;



export interface IProductInfoState {
};

class VashoManualPage extends React.Component<ComponentProps,IProductInfoState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
    };
  }

  async componentDidMount() {
    const { dispatch, language } = this.props;
    try {
      await dispatch<any>(ProductInfoActions.fetchVashoManual(language));
      dispatch<any>(VarActions.fetchVar());
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_OPEN_PARAMETERS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.openSystemParametersError',
        }
      }));
    }
  }


  render() {
    const { classes, vashoManual } = this.props;
    return (
      <div className={classes.container}>
        <div style={{ backgroundColor: 'white'}}>
          {vashoManual && vashoManual.length > 0 ? (
            <div style={{ padding: 25, paddingLeft: 20, paddingTop: 10, marginBottom: 0, backgroundColor: '#f1f1f1' }}>
              <h3 style={{ fontSize: 30, fontWeight: 'bold', marginTop: 15, marginBottom: 15 }}>{<ReduxLanguage languageKey='vars.vashoManual' />}</h3>
              <div 
                className="productInfoContentContainer"
                style={{ maxHeight: 'unset !important', padding: 25, paddingLeft: 20, paddingTop: 10, marginTop: 10, marginBottom: 0, backgroundColor: 'white', borderRadius: 10 }} 
                dangerouslySetInnerHTML={{ __html: vashoManual[0].content.rendered }} 
              />
              </div>
          ) : null}
          </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    vashoManual: state.productInfo.vashoManual.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(VashoManualPage as any));